export default {
    MAKE: {
        criteriaKey: 'makeIds',
    },
    FRAME_STYLE: {
        criteriaKey: 'frameStyleTypes',
    },
    SALE_PRICE_RANGE: {
        criteriaKey: 'salePriceRange',
    },
    EXTERIOR_COLOR: {
        criteriaKey: 'exteriorColorIds',
    },
    YEAR_RANGE: {
        criteriaKey: 'yearRange',
    },
    YEAR: {
        criteriaKey: '',
    },
    MODEL: {
        criteriaKey: 'modelIds',
    },
    ODOMETER_RANGE: {
        criteriaKey: 'odometerRange',
    },
    TRANSMISSION_TYPE: {
        criteriaKey: 'transmissionTypes',
    },
    FUEL_TYPE: {
        criteriaKey: 'fuelTypes',
    },
    DRIVE_TRAIN: {
        criteriaKey: 'drivetrains',
    },
    TEXT_QUERY: {
        criteriaKey: 'textQuery',
    },
};



// WEBPACK FOOTER //
// ./client/src/constants/metadataCategoriesCriteriaNames.js